import type { DependencyList } from 'react';
import { useKey } from 'react-use';
import type { KeyFilter } from 'react-use/lib/useKey';

const safeCallback = (callback: (e: KeyboardEvent) => void) => {
  return (e: KeyboardEvent) => {
    if (!/input|textarea/i.test(document.activeElement?.tagName || '')) {
      e.preventDefault();
      callback(e);
    }
  };
};

export const useShortcut = (
  key: KeyFilter,
  callback: (e: KeyboardEvent) => void,
  deps?: DependencyList
) => {
  useKey(key, safeCallback(callback), undefined, deps);
};
